/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { EXTERNAL_GOOGLE_CHARTS_JS_LIBRARY_URL } from '@gh/config';
import { defer$ } from '@gh/rx';
import { Observable } from 'rxjs';
import { ResourceLoader } from '../common';

@Injectable()
export class GoogleChartsLoader {
  private loaderName: string = 'chartsLoader';

  constructor(private loader: ResourceLoader) {
    loader.define(this.loaderName, EXTERNAL_GOOGLE_CHARTS_JS_LIBRARY_URL);
  }

  load(...packages: string[]): Observable<boolean> {
    packages
      .filter((packageName) => !this.loader.isDefined(packageName))
      .forEach((packageName) => this.loader.define(
        packageName,
        defer$(() => new Promise((resolve) => google.charts.load('current', {
          packages: [packageName],
          callback: resolve,
        }))),
        [this.loaderName]));

    return this.loader.require(...packages);
  }
}
